export default __webpack_public_path__ + "images/1fda4659226d9f6a55327e93301f5f02-craft.webp";